import Util from '@/lib/util'
export default [
   {
        title:Util.L('Warehouse'),
        width:100,
        key:'warehouseName',
    }]